(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vantage-brand-reveal"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const clamp = (value, min = 0, max = 1) => Math.min(max, Math.max(min, value));
    const smooth = (value) => value * value * (3 - 2 * value);
    const spring = (value) => 1 - Math.exp(-7 * value) * Math.cos(10 * value);
    const instances = new Map();

    const mount = (root) => {
      if (!root || instances.has(root)) return;

      const brands = [...root.querySelectorAll('[data-vantage-brand]')];
      let active = false;
      let ticking = false;

      const update = () => {
        ticking = false;
        if (!active) return;

        const rect = root.getBoundingClientRect();
        const distance = Math.max(1, rect.height - window.innerHeight);
        const progress = clamp(-rect.top / distance);
        const openProgress = smooth(clamp((progress - 0.08) / 0.2));
        const mobileFactor = window.innerWidth < 750 ? 0.64 : 1;

        root.style.setProperty('--box-open', openProgress.toFixed(4));

        brands.forEach((brand) => {
          const order = Number(brand.dataset.order || 1);
          const start = 0.24 + (order - 1) * 0.042;
          const local = clamp((progress - start) / 0.19);
          const movement = local > 0 ? spring(local) : 0;
          const x = Number(brand.dataset.x || 0) * movement * mobileFactor;
          const y = Number(brand.dataset.y || 40) * movement * mobileFactor;
          const finalScale = Number(brand.dataset.scale || 1);
          const scale = 0.45 + (finalScale - 0.45) * movement;
          const rotation = Number(brand.dataset.rotation || 0) * movement;
          const opacity = clamp(local * 4);

          brand.style.opacity = opacity.toFixed(3);
          brand.style.transform = `translate3d(calc(-50% + ${x}vw), calc(-50% - ${y}vh), 0) rotate(${rotation}deg) scale(${scale})`;
        });
      };

      const requestUpdate = () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(update);
      };

      const observer = new IntersectionObserver((entries) => {
        active = entries[0].isIntersecting;
        if (active) requestUpdate();
      }, { rootMargin: '100px 0px' });

      observer.observe(root);
      window.addEventListener('scroll', requestUpdate, { passive: true });
      window.addEventListener('resize', requestUpdate, { passive: true });
      instances.set(root, { observer, requestUpdate });
      requestUpdate();
    };

    const unmount = (root) => {
      const instance = instances.get(root);
      if (!instance) return;
      instance.observer.disconnect();
      window.removeEventListener('scroll', instance.requestUpdate);
      window.removeEventListener('resize', instance.requestUpdate);
      instances.delete(root);
    };

    const mountAll = (scope = document) => {
      scope.querySelectorAll('[data-vantage-reveal]').forEach(mount);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => mountAll());
    } else {
      mountAll();
    }

    document.addEventListener('shopify:section:load', (event) => mountAll(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll('[data-vantage-reveal]').forEach(unmount);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vantage-brand-reviews-pdp"] && !Shopify.designMode) return;
  try {
    
  /* Show more for the stacked review list.
     Progressive enhancement: the markup ships every card VISIBLE, and this only
     ever hides the overflow. With JS blocked the button stays hidden and the
     full list renders, which is the right failure for review content. */
  (function () {
    function setup(list) {
      if (list.dataset.vbrpReady) return;
      list.dataset.vbrpReady = '1';

      var cards = Array.prototype.slice.call(list.children);
      var initial = parseInt(list.dataset.vbrpInitial, 10) || 4;
      var button = list.parentElement.querySelector('[data-vbrp-more]');
      if (!button || cards.length <= initial) return;

      var hidden = cards.slice(initial);
      hidden.forEach(function (card) { card.setAttribute('data-vbrp-hidden', ''); });

      var label = button.querySelector('[data-vbrp-more-label]');
      function render() {
        label.textContent = 'Show ' + hidden.length + ' more review'
          + (hidden.length === 1 ? '' : 's');
      }
      render();
      button.hidden = false;

      button.addEventListener('click', function () {
        /* One step reveals everything. A paged reveal on a list this size is
           more clicks for no benefit. */
        hidden.forEach(function (card) { card.removeAttribute('data-vbrp-hidden'); });
        button.hidden = true;
        /* Move focus to the first newly shown card so a keyboard user is not
           dropped at the top of the page when the button disappears. */
        if (hidden[0]) {
          hidden[0].setAttribute('tabindex', '-1');
          hidden[0].focus({ preventScroll: true });
        }
      });
    }

    function init(root) {
      (root || document).querySelectorAll('[data-vbrp-list]').forEach(setup);
    }

    document.addEventListener('DOMContentLoaded', function () { init(); });
    init();
    /* Theme editor re-renders the section without a page load. */
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vantage-brand-videos"] && !Shopify.designMode) return;
  try {
    
  class VantageBrandVideos extends HTMLElement {
    connectedCallback() {
      this.videos = Array.from(this.querySelectorAll('video'));
      this.videos.forEach((video) => {
        video.muted = true;
        video.setAttribute('muted', '');
      });

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const video = entry.target;
            if (entry.isIntersecting) {
              const playing = video.play();
              if (playing) playing.catch(() => {});
            } else {
              video.pause();
              if (!video.muted) this.mute(video);
            }
          });
        },
        { threshold: 0.55 }
      );

      this.videos.forEach((video) => this.observer.observe(video));

      this.addEventListener('click', (event) => {
        const button = event.target.closest('[data-vbv-sound]');
        if (!button) return;
        const video = button.closest('.vbv__frame').querySelector('video');
        if (!video) return;
        video.muted ? this.unmute(video, button) : this.mute(video, button);
      });
    }

    unmute(video, button) {
      this.videos.forEach((other) => {
        if (other !== video) this.mute(other);
      });
      video.muted = false;
      video.removeAttribute('muted');
      video.controls = true;
      if (button) button.setAttribute('aria-pressed', 'true');
    }

    mute(video, button) {
      video.muted = true;
      video.setAttribute('muted', '');
      video.controls = false;
      const toggle = button || video.closest('.vbv__frame')?.querySelector('[data-vbv-sound]');
      if (toggle) toggle.setAttribute('aria-pressed', 'false');
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }
  }

  if (!customElements.get('vantage-brand-videos')) {
    customElements.define('vantage-brand-videos', VantageBrandVideos);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vantage-color-showcase"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.vcs[data-section]').forEach(function (sec) {
    var id = sec.dataset.section;
    var panels = Array.from(sec.querySelectorAll('.vcs__panel'));
    var btns   = Array.from(sec.querySelectorAll('.vcs__sw-btn'));
    var cursor = document.getElementById('vcs-cursor-' + id);
    var pill   = document.getElementById('vcs-pill-' + id);
    var glowA  = document.getElementById('vcs-ga-' + id);
    var glowB  = document.getElementById('vcs-gb-' + id);
    var glows  = [glowA, glowB];
    var slot   = 0;

    function hex2rgb(h) {
      var r = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(h);
      return r ? [parseInt(r[1],16), parseInt(r[2],16), parseInt(r[3],16)] : [196,98,45];
    }

    function moveCursor(btn) {
      if (!cursor || !pill) return;
      var pr = pill.getBoundingClientRect();
      var br = btn.getBoundingClientRect();
      cursor.style.left  = (br.left - pr.left) + 'px';
      cursor.style.width = br.width + 'px';
    }

    function animateBars(panel) {
      panel.querySelectorAll('.vcs__fill').forEach(function (f) {
        f.style.transition = 'none';
        f.style.width = '0';
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            f.style.transition = 'width 1s cubic-bezier(.4,0,.2,1)';
            f.style.width = (f.dataset.v || 0) + '%';
          });
        });
      });
    }

    function setGlow(accent) {
      var rgb = hex2rgb(accent);
      var next = 1 - slot;
      glows[next].style.background = 'radial-gradient(circle at 34% 55%, rgba(' + rgb + ',.14), transparent 52%)';
      glows[next].style.opacity = '1';
      glows[slot].style.opacity = '0';
      slot = next;
      sec.style.setProperty('--vcs-accent', accent);
      var glow = sec.querySelector('.vcs__panel.is-active .vcs__vis-glow');
      if (glow) glow.style.background = accent;
    }

    function activate(idx) {
      var panel = panels[idx];
      var btn   = btns[idx];
      if (!panel) return;
      var accent = panel.dataset.accent || '#C4622D';

      panels.forEach(function (p) { p.classList.remove('is-active', 'vcs--play'); });
      btns.forEach(function (b) {
        b.classList.remove('is-active');
        b.setAttribute('aria-selected', 'false');
      });

      panel.classList.add('is-active');
      panel.offsetHeight;
      panel.classList.add('vcs--play');

      btn.classList.add('is-active');
      btn.setAttribute('aria-selected', 'true');

      moveCursor(btn);
      setGlow(accent);
      setTimeout(function () { animateBars(panel); }, 160);
    }

    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        activate(parseInt(btn.dataset.idx, 10));
      });
    });

    window.addEventListener('resize', function () {
      var active = btns.find(function (b) { return b.classList.contains('is-active'); });
      if (active) moveCursor(active);
    });

    /* Init */
    if (panels.length) {
      var a0 = panels[0].dataset.accent || '#C4622D';
      var rgb0 = hex2rgb(a0);
      if (glowA) glowA.style.background = 'radial-gradient(circle at 34% 55%, rgba(' + rgb0 + ',.14), transparent 52%)';
      sec.style.setProperty('--vcs-accent', a0);
      setTimeout(function () { animateBars(panels[0]); }, 500);
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          if (btns[0]) moveCursor(btns[0]);
        });
      });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vantage-expand-cards"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.vec[data-section]').forEach(function (section) {
    var cards = Array.from(section.querySelectorAll('.vec__card'));

    function activate(card) {
      cards.forEach(function (c) { c.classList.remove('is-active'); });
      card.classList.add('is-active');
    }

    cards.forEach(function (card) {
      card.addEventListener('click', function () { activate(card); });
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); activate(card); }
      });
    });

    /* Stagger entry animation */
    cards.forEach(function (card, i) {
      card.style.animationDelay = (140 * i) + 'ms';
      setTimeout(function () {
        card.classList.add('vec--in');
      }, 0);
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vantage-faq"] && !Shopify.designMode) return;
  try {
    
/* Emits proof_expand so "which objection are people actually opening?" is answerable.
   PostHog/dataLayer may be absent (ad blockers, consent) — never throw. */
document.querySelectorAll('.vfaq__item').forEach(function (item) {
  item.addEventListener('toggle', function () {
    if (!item.open) return;
    var q = item.querySelector('.vfaq__q span');
    var payload = { module: 'faq', question: q ? q.textContent.trim() : '' };
    try {
      if (window.posthog && typeof window.posthog.capture === 'function') {
        window.posthog.capture('proof_expand', payload);
      }
      (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: 'proof_expand' }, payload));
    } catch (e) {}
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vantage-feature-showcase"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.vfs[data-section]').forEach(function (section) {
    var id = section.dataset.section;
    var speed = parseInt(section.dataset.speed, 10) || 7000;

    var feats   = Array.from(section.querySelectorAll('.vfs__feat'));
    var cards   = Array.from(section.querySelectorAll('.vfs__card'));
    var bar     = section.querySelector('#vfs-bar-' + id);
    var total   = feats.length;

    if (total === 0) return;

    var ITEM_H  = 62;
    var current = 0;
    var timer   = null;
    var paused  = false;

    /* ── Position drum items ── */
    function positionFeats(idx) {
      feats.forEach(function (feat, i) {
        var dist = i - idx;
        if (dist > total / 2)  dist -= total;
        if (dist < -total / 2) dist += total;

        var y   = dist * ITEM_H;
        var op  = Math.max(0, 1 - Math.abs(dist) * 0.28);

        feat.style.transform   = 'translateY(calc(-50% + ' + y + 'px))';
        feat.style.opacity     = feat.classList.contains('is-active') ? '1' : op;
        feat.classList.toggle('is-active', i === idx);
        feat.setAttribute('aria-selected', i === idx ? 'true' : 'false');
      });
    }

    /* ── Update card states ── */
    function positionCards(idx) {
      cards.forEach(function (card, i) {
        var dist = i - idx;
        if (dist > total / 2)  dist -= total;
        if (dist < -total / 2) dist += total;

        card.classList.remove('is-active', 'is-prev', 'is-next');
        card.setAttribute('aria-hidden', 'true');

        if (dist === 0) {
          card.classList.add('is-active');
          card.setAttribute('aria-hidden', 'false');
        } else if (dist === -1 || dist === total - 1) {
          card.classList.add('is-prev');
        } else if (dist === 1 || dist === -(total - 1)) {
          card.classList.add('is-next');
        }
      });
    }

    /* ── Progress bar ── */
    function startBar() {
      if (!bar) return;
      bar.style.transition = 'none';
      bar.style.width = '0%';
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          bar.style.transition = 'width ' + (speed / 1000) + 's linear';
          bar.style.width = '100%';
        });
      });
    }

    /* ── Navigate to index ── */
    function goTo(idx) {
      current = ((idx % total) + total) % total;
      positionFeats(current);
      positionCards(current);
      startBar();
    }

    /* ── Auto-play ── */
    function startTimer() {
      clearInterval(timer);
      timer = setInterval(function () {
        if (!paused) goTo(current + 1);
      }, speed);
    }

    /* ── Feature click ── */
    feats.forEach(function (feat) {
      feat.addEventListener('click', function () {
        goTo(parseInt(feat.dataset.idx, 10));
        clearInterval(timer);
        startTimer();
      });
      feat.addEventListener('mouseenter', function () { paused = true; });
      feat.addEventListener('mouseleave', function () { paused = false; });
    });

    /* ── Pause on section hover ── */
    section.addEventListener('mouseenter', function () { paused = true; });
    section.addEventListener('mouseleave', function () { paused = false; });

    /* ── Init ── */
    goTo(0);
    startTimer();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vantage-pdp-hero-football"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.vpdp[data-section]').forEach(function (root) {
    var id = root.dataset.section;
    var dataEl = document.getElementById('vpdp-data-' + id);
    if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    var optionNames = (root.dataset.optionNames || '').split(',');
    var refs = {};
    root.querySelectorAll('[data-ref]').forEach(function (el) {
      var k = el.dataset.ref;
      if (refs[k]) { Array.isArray(refs[k]) ? refs[k].push(el) : (refs[k] = [refs[k], el]); }
      else refs[k] = el;
    });
    var arr = function (v) { return Array.isArray(v) ? v : v ? [v] : []; };
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function money(cents) {
      var f = root.dataset.moneyFormat || '{' + '{amount}}';
      var m = f.match(/\{\{\s*(\w+)\s*\}\}/);
      var key = m ? m[1] : 'amount';
      var n = cents / 100;
      var s;
      if (key.indexOf('no_decimals') !== -1) {
        s = Math.round(n).toLocaleString();
      } else if (key.indexOf('comma_separator') !== -1) {
        s = n.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      } else {
        s = n.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      }
      return f.replace(/\{\{[^}]+\}\}/, s);
    }

    function announce(msg) {
      if (refs.live) refs.live.textContent = msg;
    }

    /* ── Gallery / lightbox ── */
    var featureItems = root.querySelectorAll('.vpdp__feature-item');
    var lbItems = root.querySelectorAll('.vpdp__lb-item');
    var lightbox = refs.lightbox;
    var lbIdx = 0;
    var mediaCount = lbItems.length;

    function setFeature(idx) {
      featureItems.forEach(function (el, i) { el.classList.toggle('is-active', i === idx); });
    }

    var zoomScale = 1, zoomX = 0, zoomY = 0;
    function activeLbImg() {
      var item = lbItems[lbIdx];
      return item ? item.querySelector('.vpdp__lb-img') : null;
    }
    function applyZoom() {
      var img = activeLbImg();
      if (!img) return;
      img.style.transform = zoomScale > 1 ? 'translate(' + zoomX + 'px,' + zoomY + 'px) scale(' + zoomScale + ')' : '';
      lightbox.classList.toggle('is-zoomed', zoomScale > 1);
    }
    function resetZoom() { zoomScale = 1; zoomX = 0; zoomY = 0; applyZoom(); }

    function showLb(idx) {
      if (!mediaCount) return;
      lbIdx = (idx + mediaCount) % mediaCount;
      resetZoom();
      lbItems.forEach(function (el, i) {
        el.classList.toggle('is-active', i === lbIdx);
        var vid = el.querySelector('video');
        if (vid && i !== lbIdx) vid.pause();
      });
      if (refs.lbCount) refs.lbCount.textContent = (lbIdx + 1) + ' / ' + mediaCount;
    }
    function openLb(idx) {
      trackEvent('media_engage', { media_position: idx + 1, media_count: mediaCount, type: 'lightbox_open' });
      if (!lightbox) return;
      showLb(idx);
      lightbox.showModal();
    }

    if (refs.featureZoom) refs.featureZoom.addEventListener('click', function () {
      var active = root.querySelector('.vpdp__feature-item.is-active');
      openLb(active ? parseInt(active.dataset.idx, 10) : 0);
    });
    root.querySelectorAll('.vpdp__tile, .vpdp__carousel-slide').forEach(function (btn) {
      btn.addEventListener('click', function () { openLb(parseInt(btn.dataset.idx, 10)); });
    });
    if (lightbox) {
      if (refs.lbClose) refs.lbClose.addEventListener('click', function () { lightbox.close(); });
      if (refs.lbPrev) refs.lbPrev.addEventListener('click', function () { showLb(lbIdx - 1); });
      if (refs.lbNext) refs.lbNext.addEventListener('click', function () { showLb(lbIdx + 1); });
      lightbox.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') showLb(lbIdx - 1);
        if (e.key === 'ArrowRight') showLb(lbIdx + 1);
      });
      lightbox.addEventListener('close', function () {
        lbItems.forEach(function (el) {
          var vid = el.querySelector('video');
          if (vid) vid.pause();
        });
        resetZoom();
      });

      var stage = refs.lbStage;
      var pointers = new Map();
      var pinchStartDist = 0, pinchStartScale = 1;
      function dist() {
        var p = Array.from(pointers.values());
        return Math.hypot(p[0].x - p[1].x, p[0].y - p[1].y);
      }
      stage.addEventListener('pointerdown', function (e) {
        pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });
        if (pointers.size === 2) { pinchStartDist = dist(); pinchStartScale = zoomScale; }
      });
      stage.addEventListener('pointermove', function (e) {
        if (!pointers.has(e.pointerId)) return;
        var prev = pointers.get(e.pointerId);
        pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });
        if (pointers.size === 2) {
          zoomScale = Math.min(4, Math.max(1, pinchStartScale * (dist() / pinchStartDist)));
          applyZoom();
        } else if (pointers.size === 1 && zoomScale > 1) {
          zoomX += e.clientX - prev.x;
          zoomY += e.clientY - prev.y;
          applyZoom();
        }
      });
      ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (evt) {
        stage.addEventListener(evt, function (e) { pointers.delete(e.pointerId); });
      });
      stage.addEventListener('click', function (e) {
        if (pointers.size > 0) return;
        var img = activeLbImg();
        if (!img || !img.contains(e.target)) return;
        if (zoomScale > 1) { resetZoom(); return; }
        zoomScale = 2.4;
        var r = img.getBoundingClientRect();
        zoomX = (r.left + r.width / 2 - e.clientX) * (zoomScale - 1);
        zoomY = (r.top + r.height / 2 - e.clientY) * (zoomScale - 1);
        applyZoom();
      });
    }

    /* ── Mobile carousel dots ── */
    var track = refs.carouselTrack;
    var dots = refs.dots ? refs.dots.querySelectorAll('.vpdp__dot') : [];
    if (track && dots.length) {
      var dotTick = false;
      track.addEventListener('scroll', function () {
        if (dotTick) return;
        dotTick = true;
        requestAnimationFrame(function () {
          dotTick = false;
          var idx = Math.round(track.scrollLeft / track.clientWidth);
          dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
        });
      }, { passive: true });
    }
    function scrollCarouselTo(idx) {
      if (track) track.scrollTo({ left: idx * track.clientWidth, behavior: reduceMotion ? 'auto' : 'smooth' });
    }

    /* ── Variant engine ── */
    var form = refs.form || document.getElementById('vpdp-form-' + id);
    var vidInput = refs.variantId;
    var activeVariant = variants.find(function (v) { return String(v.id) === (vidInput ? vidInput.value : ''); }) || variants[0];
    var selectedOpts = activeVariant ? activeVariant.options.slice() : [];

    function findVariant(opts) {
      opts = opts || selectedOpts;
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }
    function valueHasVariant(pos, val) {
      return variants.some(function (v) {
        return v.options.every(function (o, i) { return i === pos ? o === val : o === selectedOpts[i]; });
      });
    }

    function syncInputs() {
      root.querySelectorAll('input[type="radio"][data-pos]').forEach(function (input) {
        var pos = parseInt(input.dataset.pos, 10);
        input.checked = input.value === selectedOpts[pos];
        input.disabled = !valueHasVariant(pos, input.value);
      });
      arr(refs.optionSelect).forEach(function (sel) {
        sel.value = selectedOpts[parseInt(sel.dataset.pos, 10)];
      });
    }

    function priceHTML(v) {
      var html = '<span class="vpdp__price-now">' + money(v.price) + '</span>';
      if (v.compare_at_price && v.compare_at_price > v.price) {
        html += '<s class="vpdp__price-was">' + money(v.compare_at_price) + '</s>';
        var pctMode = root.dataset.pct;
        if (pctMode && pctMode !== 'off') {
          var pct = ((v.compare_at_price - v.price) / v.compare_at_price) * 100;
          pct = pctMode === 'floor' ? Math.floor(pct) : Math.round(pct);
          if (pct >= 1) {
            html += '<span class="vpdp__price-pct">' + pct + '% ' + (root.dataset.pctLabel || 'Off') + '</span>';
          }
        }
      }
      return html;
    }

    function updateUI(v) {
      if (!v) {
        [refs.atc, refs.barAtc].forEach(function (b) { if (b) { b.disabled = true; b.setAttribute('aria-disabled', 'true'); } });
        [refs.atcLabel, refs.barAtcLabel].forEach(function (l) { if (l) l.textContent = 'Unavailable'; });
        announce('Selected combination is unavailable');
        return;
      }
      activeVariant = v;
      if (vidInput) vidInput.value = v.id;
      if (refs.price) refs.price.innerHTML = priceHTML(v);
      if (refs.barPrice) refs.barPrice.textContent = money(v.price);
      [refs.atc, refs.barAtc].forEach(function (b) {
        if (b) { b.disabled = !v.available; b.setAttribute('aria-disabled', String(!v.available)); }
      });
      [refs.atcLabel, refs.barAtcLabel].forEach(function (l) {
        if (l) l.textContent = v.available ? 'Add to cart' : 'Sold out';
      });
      /* ponytail: button price is the selected variant, not a bundle-inclusive total —
         bundle discounts are applied as codes at checkout, so a "final total" here would lie. */
      if (refs.atcPrice) refs.atcPrice.textContent = v.available ? money(v.price) : '';
      if (refs.sku) refs.sku.textContent = v.sku || root.dataset.productId;
      if (refs.colorName) {
        var swatchGroup = root.querySelector('.vpdp__swatches input[data-pos]');
        if (swatchGroup) refs.colorName.textContent = selectedOpts[parseInt(swatchGroup.dataset.pos, 10)];
      }
      var u = new URL(window.location.href);
      u.searchParams.set('variant', v.id);
      history.replaceState({}, '', u.toString());
      if (v.featured_image && v.featured_image.position) {
        setFeature(v.featured_image.position - 1);
        scrollCarouselTo(v.featured_image.position - 1);
      }
      announce(v.title + ', ' + money(v.price) + (v.available ? '' : ', sold out'));
      /* Lets variant-aware sections below the fold (e.g. the O3 colour explorer) mirror the
         real selection instead of keeping a second, driftable copy of the variant state. */
      document.dispatchEvent(new CustomEvent('vpdp:variant', {
        detail: { sectionId: id, variant: v, options: selectedOpts.slice(), optionNames: optionNames }
      }));
    }

    function onOptionChange(pos, val) {
      selectedOpts[pos] = val;
      if (!findVariant()) {
        var fallback = variants.find(function (v) { return v.options[pos] === val; });
        if (fallback) selectedOpts = fallback.options.slice();
      }
      syncInputs();
      var picked = findVariant();
      updateUI(picked);
      trackEvent('variant_select', {
        option: optionNames[pos] || 'option_' + pos,
        value: val,
        available: !!(picked && picked.available)
      });
    }

    root.querySelectorAll('input[type="radio"][data-pos]').forEach(function (input) {
      input.addEventListener('change', function () {
        onOptionChange(parseInt(input.dataset.pos, 10), input.value);
      });
    });
    arr(refs.optionSelect).forEach(function (sel) {
      sel.addEventListener('change', function () {
        onOptionChange(parseInt(sel.dataset.pos, 10), sel.value);
      });
    });

    if ('requestIdleCallback' in window) {
      requestIdleCallback(function () {
        variants.forEach(function (v) {
          if (v.featured_image && v.featured_image.src) {
            new Image().src = v.featured_image.src + (v.featured_image.src.indexOf('?') > -1 ? '&' : '?') + 'width=1400';
          }
        });
      });
    }

    /* ── Analytics ──
       PostHog is loaded by the PixieHog app, GTM by the theme; both may be absent
       (ad blockers, consent tools), so every call is guarded and never throws. */
    function trackEvent(name, props) {
      var base = {
        product_id: root.dataset.productId,
        product_title: root.dataset.productTitle,
        variant_id: activeVariant ? String(activeVariant.id) : null,
        variant_title: activeVariant ? activeVariant.title : null,
        price: activeVariant ? activeVariant.price / 100 : null,
        currency: root.dataset.currency,
        viewport: window.innerWidth < 750 ? 'mobile' : 'desktop'
      };
      var payload = Object.assign(base, props || {});
      try {
        if (window.posthog && typeof window.posthog.capture === 'function') {
          window.posthog.capture(name, payload);
        }
        (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, payload));
      } catch (e) { /* analytics must never break the buy flow */ }
    }

    /* ── Add to cart (AJAX, reuses theme cart events) ── */
    /* items: [{ id, quantity, properties? }] — one request, so a failure adds nothing */
    function addToCart(items, btn, sourceId) {
      if (btn && btn.classList.contains('is-loading')) return Promise.resolve(false);
      if (btn) btn.classList.add('is-loading');
      var sectionIds = [];
      document.querySelectorAll('cart-items-component').forEach(function (el) {
        if (el.dataset.sectionId) sectionIds.push(el.dataset.sectionId);
      });
      var payload = { items: items };
      if (sectionIds.length) payload.sections = sectionIds.join(',');
      var addUrl = (window.Theme && Theme.routes && Theme.routes.cart_add_url) || '/cart/add.js';
      return fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (r) { return r.json(); })
        .then(function (resp) {
          if (resp.status) {
            announce(resp.description || resp.message || 'Could not add to cart');
            trackEvent('add_to_cart_error', { error_type: resp.description || resp.message || 'unknown', source: sourceId });
            return false;
          }
          trackEvent('pdp_add_to_cart', {
            quantity: items.reduce(function (n, it) { return n + (it.quantity || 1); }, 0),
            line_items: items.length,
            bundle_items: Math.max(0, items.length - 1),
            source: sourceId
          });
          return fetch('/cart.js')
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              root.dispatchEvent(new CustomEvent('cart:update', {
                bubbles: true,
                detail: {
                  resource: cart,
                  sourceId: sourceId,
                  data: {
                    source: 'product-form-component',
                    itemCount: items.reduce(function (n, it) { return n + (it.quantity || 1); }, 0),
                    productId: root.dataset.productId,
                    variantId: String(items[0].id),
                    sections: resp.sections
                  }
                }
              }));
              announce('Added to cart');
              return true;
            });
        })
        .catch(function () {
          announce('Could not add to cart. Please try again.');
          trackEvent('add_to_cart_error', { error_type: 'network', source: sourceId });
          return false;
        })
        .finally(function () {
          if (btn) btn.classList.remove('is-loading');
        });
    }

    /* ── Bundle & Save ── */
    var bundleStates = [];
    var bundleEl = refs.bundle;
    var updateBundle = function () {};
    if (bundleEl) {
      var bundleDataEl = document.getElementById('vbs-data-' + id);
      var bundleData = [];
      try { bundleData = JSON.parse(bundleDataEl.textContent); } catch (e) { bundleData = []; }
      var bundleTiers = [
        { offer: 'Add 1, Save 5%', msg: 'Add 1 accessory to save 5%.', fill: 0, now: 0, text: 'No bundle discount unlocked', pct: 0 },
        { offer: 'Add 2, Save 10%', msg: 'You added 1 accessory. Add 1 more to save 10%!', fill: 0.5, now: 5, text: '5% bundle discount unlocked', pct: 5 },
        { offer: 'Bundle complete: Save 10%', msg: 'You added 2 accessories and unlocked 10% off!', fill: 1, now: 10, text: '10% bundle discount unlocked', pct: 10 }
      ];

      function swapText(el, text) {
        if (!el || el.textContent === text) return;
        el.textContent = text;
        if (!reduceMotion && el.animate) {
          el.animate(
            [{ opacity: 0, transform: 'translateY(4px)' }, { opacity: 1, transform: 'none' }],
            { duration: 250, easing: 'ease-out' }
          );
        }
      }

      bundleEl.querySelectorAll('[data-vbs-item]').forEach(function (row) {
        var pid = parseInt(row.dataset.productId, 10);
        var data = null;
        bundleData.forEach(function (d) { if (d.productId === pid) data = d; });
        if (!data) return;
        var sel = row.querySelector('[data-vbs-variant]');
        var pickVariant = function () {
          var vid = sel ? parseInt(sel.value, 10) : 0;
          var match = null;
          data.variants.forEach(function (v) {
            if (sel ? v.id === vid : (!match && v.available)) match = v;
          });
          return match || data.variants[0];
        };
        var state = {
          row: row,
          qty: 0,
          soldout: !data.available,
          variant: pickVariant(),
          els: {
            minus: row.querySelector('[data-vbs-minus]'),
            plus: row.querySelector('[data-vbs-plus]'),
            count: row.querySelector('[data-vbs-count]'),
            price: row.querySelector('[data-vbs-price]'),
            compare: row.querySelector('[data-vbs-compare]'),
            deal: row.querySelector('[data-vbs-deal]'),
            img: row.querySelector('.vbs__img'),
            added: row.querySelector('[data-vbs-added]')
          }
        };
        bundleStates.push(state);

        state.els.plus.addEventListener('click', function () {
          if (state.qty >= 1 || state.soldout) return;
          state.qty = 1;
          updateBundle(true);
        });
        state.els.minus.addEventListener('click', function () {
          if (state.qty === 0) return;
          state.qty = 0;
          updateBundle(true);
        });
        if (sel) {
          sel.addEventListener('change', function () {
            state.variant = pickVariant();
            if (state.els.price) state.els.price.textContent = money(state.variant.price);
            if (state.els.compare) {
              var cmp = state.variant.compare_at_price;
              state.els.compare.hidden = !(cmp && cmp > state.variant.price);
              if (!state.els.compare.hidden) state.els.compare.textContent = money(cmp);
            }
            if (state.els.img && state.variant.featured_image && state.variant.featured_image.src) {
              state.els.img.src = state.variant.featured_image.src;
              state.els.img.removeAttribute('srcset');
            }
            updateBundle(false);
          });
        }
      });

      updateBundle = function (announceChange) {
        var count = 0;
        bundleStates.forEach(function (s) { if (s.qty > 0 && !s.soldout) count = count + 1; });
        var tier = bundleTiers[Math.min(count, 2)];
        swapText(refs.bundleOffer, tier.offer);
        swapText(refs.bundleMsg, tier.msg);
        if (refs.bundleFill) refs.bundleFill.style.transform = 'scaleX(' + tier.fill + ')';
        if (refs.bundleBar) {
          refs.bundleBar.setAttribute('aria-valuenow', String(tier.now));
          refs.bundleBar.setAttribute('aria-valuetext', tier.text);
        }
        if (refs.bundleTick5) refs.bundleTick5.classList.toggle('is-unlocked', count >= 1);
        if (refs.bundleTick10) refs.bundleTick10.classList.toggle('is-unlocked', count >= 2);
        if (refs.bundleBadge) refs.bundleBadge.classList.toggle('is-on', count >= 2);
        bundleStates.forEach(function (s) {
          var selected = s.qty > 0 && !s.soldout;
          s.row.classList.toggle('is-selected', selected);
          if (s.els.count) s.els.count.textContent = String(s.qty);
          if (s.els.added) s.els.added.hidden = !selected;
          if (s.els.minus) s.els.minus.disabled = s.qty === 0;
          if (s.els.plus) s.els.plus.disabled = s.qty >= 1 || s.soldout;
          if (s.els.deal && s.els.price) {
            if (selected && tier.pct > 0) {
              s.els.deal.hidden = false;
              s.els.deal.textContent = money(Math.round(s.variant.price * (1 - tier.pct / 100))) + ' in bundle';
              s.els.price.classList.add('is-struck');
            } else {
              s.els.deal.hidden = true;
              s.els.price.classList.remove('is-struck');
            }
          }
        });
        if (announceChange) announce(tier.text + '. ' + tier.msg);
      };
      updateBundle(false);
    }

    function buildCartItems() {
      var items = [{ id: activeVariant.id, quantity: 1 }];
      var selected = bundleStates.filter(function (s) { return s.qty > 0 && !s.soldout && s.variant && s.variant.available; });
      if (selected.length) {
        var bid = 'vgb-' + Date.now();
        var tierName = selected.length >= 2 ? '10' : '5';
        items[0].properties = { _vg_role: 'case', _vg_bundle: bid, _vg_tier: tierName };
        selected.forEach(function (s) {
          items.push({
            id: s.variant.id,
            quantity: 1,
            properties: { _vg_role: 'accessory', _vg_bundle: bid, _vg_tier: tierName, _vg_parent: String(activeVariant.id) }
          });
        });
      }
      return items;
    }

    function resetBundle() {
      if (!bundleStates.length) return;
      bundleStates.forEach(function (s) { s.qty = 0; });
      updateBundle(false);
    }

    function submitMain(btn, sourceId) {
      if (!activeVariant || !activeVariant.available) return;
      var items = buildCartItems();
      addToCart(items, btn, sourceId).then(function (ok) {
        if (ok && items.length > 1) resetBundle();
      });
    }
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        submitMain(refs.atc, form.id);
      });
    }
    if (refs.barAtc) {
      refs.barAtc.addEventListener('click', function () {
        var depth = document.documentElement.scrollHeight - window.innerHeight;
        trackEvent('sticky_cta_click', {
          scroll_depth_pct: depth > 0 ? Math.round((window.scrollY / depth) * 100) : 0
        });
        submitMain(refs.barAtc, form ? form.id : id);
      });
    }
    arr(refs.stackAdd).forEach(function (btn) {
      btn.addEventListener('click', function () {
        addToCart([{ id: parseInt(btn.dataset.variantId, 10), quantity: 1 }], btn, id).then(function (ok) {
          if (!ok) return;
          btn.classList.add('is-added');
          var label = btn.querySelector('span');
          if (label) label.textContent = 'Added';
          setTimeout(function () {
            btn.classList.remove('is-added');
            if (label) label.textContent = 'Add';
          }, 2000);
        });
      });
    });

    /* ── Analytics wiring for disclosures, bundle and first view ── */
    root.querySelectorAll('.vpdp__acc').forEach(function (acc) {
      acc.addEventListener('toggle', function () {
        if (!acc.open) return;
        var label = acc.querySelector('summary span');
        trackEvent('proof_expand', { module: 'buy_box_accordion', question: label ? label.textContent.trim() : '' });
      });
    });

    if (bundleEl) {
      var bundleDetails = bundleEl.closest('details') || bundleEl.querySelector('details');
      if (bundleDetails) {
        bundleDetails.addEventListener('toggle', function () {
          if (bundleDetails.open) trackEvent('bundle_open', { position: 'below_cta' });
        });
      } else {
        /* bundle renders open — count the first interaction as the open signal */
        var bundleSeen = false;
        bundleEl.addEventListener('click', function () {
          if (bundleSeen) return;
          bundleSeen = true;
          trackEvent('bundle_open', { position: 'below_cta' });
        }, true);
      }
      bundleEl.querySelectorAll('[data-vbs-plus]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var row = btn.closest('[data-vbs-item]');
          var state = bundleStates.find(function (s) { return s.row === row; });
          trackEvent('bundle_select', {
            accessory_product_id: row ? row.dataset.productId : null,
            accessory_variant_id: state && state.variant ? String(state.variant.id) : null,
            incremental_price: state && state.variant ? state.variant.price / 100 : null
          });
        });
      });
    }

    trackEvent('pdp_view', {
      template: root.dataset.template,
      media_count: mediaCount,
      has_bundle: !!bundleEl
    });

    /* ── Open the mobile carousel on the selected variant's image, matching the Liquid feature.
       Positioned by slide offset, not clientWidth: at init the track may not be laid out yet. ── */
    if (track && activeVariant && activeVariant.featured_image && activeVariant.featured_image.position > 1) {
      var initSlide = track.querySelectorAll('.vpdp__carousel-slide')[activeVariant.featured_image.position - 1];
      if (initSlide) {
        requestAnimationFrame(function () {
          track.scrollLeft = initSlide.offsetLeft - track.offsetLeft;
        });
      }
    }

    /* ── Gift dialog ── */
    if (refs.giftLearn && refs.giftDialog) {
      refs.giftLearn.addEventListener('click', function () { refs.giftDialog.showModal(); });
      if (refs.giftClose) refs.giftClose.addEventListener('click', function () { refs.giftDialog.close(); });
      refs.giftDialog.addEventListener('click', function (e) {
        if (e.target === refs.giftDialog) refs.giftDialog.close();
      });
    }

    /* ── Reviews scroll ── */
    if (refs.reviewsLink) {
      refs.reviewsLink.addEventListener('click', function () {
        var target = document.querySelector('.vtm')
          || document.querySelector('[id*="testimonials"]')
          || document.querySelector('.jdgm-rev-widg, .jdgm-widget')
          || document.querySelector('[id*="reviews"]');
        if (target) target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth' });
      });
    }

    /* ── Sticky panel top (lets tall panels scroll before sticking) ── */
    var panel = refs.panel;
    if (panel && 'ResizeObserver' in window) {
      var setStickyTop = function () {
        var header = parseFloat(getComputedStyle(document.body).getPropertyValue('--header-height')) || 60;
        panel.style.top = Math.min(header + 24, window.innerHeight - panel.offsetHeight - 24) + 'px';
      };
      new ResizeObserver(setStickyTop).observe(panel);
      window.addEventListener('resize', setStickyTop);
      setStickyTop();
    }

    /* ── Mobile sticky bar ── */
    if (refs.atc && refs.stickyBar && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        /* Off-screen in either direction — see vantage-pdp-hero.liquid for why. */
        refs.stickyBar.classList.toggle('is-visible', !e.isIntersecting);
      }).observe(refs.atc);
    }

    /* ── Back to top ── */
    if (refs.backToTop) {
      var topTick = false;
      window.addEventListener('scroll', function () {
        if (topTick) return;
        topTick = true;
        requestAnimationFrame(function () {
          topTick = false;
          refs.backToTop.classList.toggle('is-visible', window.scrollY > 500);
        });
      }, { passive: true });
      refs.backToTop.addEventListener('click', function () {
        window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
      });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vantage-pdp-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.vpdp[data-section]').forEach(function (root) {
    var id = root.dataset.section;
    var dataEl = document.getElementById('vpdp-data-' + id);
    if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    var optionNames = (root.dataset.optionNames || '').split(',');
    var refs = {};
    root.querySelectorAll('[data-ref]').forEach(function (el) {
      var k = el.dataset.ref;
      if (refs[k]) { Array.isArray(refs[k]) ? refs[k].push(el) : (refs[k] = [refs[k], el]); }
      else refs[k] = el;
    });
    var arr = function (v) { return Array.isArray(v) ? v : v ? [v] : []; };
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function money(cents) {
      var f = root.dataset.moneyFormat || '{' + '{amount}}';
      var m = f.match(/\{\{\s*(\w+)\s*\}\}/);
      var key = m ? m[1] : 'amount';
      var n = cents / 100;
      var s;
      if (key.indexOf('no_decimals') !== -1) {
        s = Math.round(n).toLocaleString();
      } else if (key.indexOf('comma_separator') !== -1) {
        s = n.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      } else {
        s = n.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      }
      return f.replace(/\{\{[^}]+\}\}/, s);
    }

    /* Shipping tiers. Display only: the real charge is a Shopify delivery rate
       at checkout, so this must never be added to the add-to-cart price. */
    var tierButtons = refs.shipTiers
      ? Array.prototype.slice.call(refs.shipTiers.querySelectorAll('.vpdp__tier'))
      : [];
    var selectedTier = null;

    function tierFromButton(btn) {
      return {
        name: btn.dataset.tier,
        adds: parseInt(btn.dataset.adds, 10) || 0,
        minDays: parseInt(btn.dataset.minDays, 10) || 0,
        maxDays: parseInt(btn.dataset.maxDays, 10) || 0
      };
    }

    /* What the selected tier ADDS to the price. Zero for every combination
       except an Instant upgrade on a product whose price paid for Standard:
       see snippets/vantage-ship-tiers.liquid for why. */
    function feeFor(tier) {
      return tier ? tier.adds : 0;
    }

    /* The price the shopper actually pays for the goods, tier included. This
       is what the big price shows, so there is only ever one number on screen. */
    function deliveredPrice(variant) {
      if (!variant) return 0;
      return variant.price + feeFor(selectedTier);
    }

    /* Working days only: a shopper reading "arrives Saturday" on a courier that
       does not move on Sunday is a support ticket waiting to happen. */
    function addWorkingDays(days) {
      var d = new Date();
      var added = 0;
      while (added < days) {
        d.setDate(d.getDate() + 1);
        if (d.getDay() !== 0 && d.getDay() !== 6) added++;
      }
      return d;
    }

    function dayLabel(date) {
      return date.toLocaleDateString(undefined, { day: 'numeric', month: 'short' });
    }

    /* The line under the chips carries the ARRIVAL promise. The money moved up
       into the big price, so repeating a total here would put two prices on
       screen, which is the confusion this change exists to remove. */
    function updateShipTotal() {
      if (!selectedTier || !activeVariant) return;
      if (refs.price) refs.price.innerHTML = priceHTML(activeVariant);
      if (refs.barPrice) refs.barPrice.textContent = money(deliveredPrice(activeVariant));
      if (refs.shipTotal) {
        var arrival = dayLabel(addWorkingDays(selectedTier.minDays)) +
          ' to ' + dayLabel(addWorkingDays(selectedTier.maxDays));
        refs.shipTotal.textContent = 'Arrives ' + arrival;
      }
      if (refs.shipProp) refs.shipProp.value = selectedTier.name;
      tierButtons.forEach(function (b) {
        b.setAttribute('aria-pressed', String(b.dataset.tier === selectedTier.name));
      });
    }

    /* aria-disabled, not disabled: an ineligible chip stays focusable and
       clickable so screen reader users can discover it exists. The listener
       fires for every chip; ineligible ones are rejected inside the handler
       instead of never being wired up. */
    tierButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.getAttribute('aria-disabled') === 'true') return;
        selectedTier = tierFromButton(btn);
        updateShipTotal();
      });
    });

    /* Preselect whatever the server already marked aria-pressed="true" —
       markup and JS must agree on which tier looks selected on load — and
       fall back to the first eligible chip if none is marked. */
    (function () {
      var pre = tierButtons.filter(function (b) { return b.getAttribute('aria-pressed') === 'true'; })[0] ||
        tierButtons.filter(function (b) { return b.getAttribute('aria-disabled') !== 'true'; })[0];
      if (pre) selectedTier = tierFromButton(pre);
    })();

    function announce(msg) {
      if (refs.live) refs.live.textContent = msg;
    }

    /* ── Gallery / lightbox ── */
    var featureItems = root.querySelectorAll('.vpdp__feature-item');
    var lbItems = root.querySelectorAll('.vpdp__lb-item');
    var lightbox = refs.lightbox;
    var lbIdx = 0;
    var mediaCount = lbItems.length;

    /* ── Device-scoped gallery and title ──
       A merged product carries every device's images in one gallery. The merge
       script writes each image's alt as "<Device>: ...", so the tag is already
       in the DOM. A tag is only honoured if it matches a real Device option
       value taken from the variant JSON, so a supplier alt that happens to
       contain a colon cannot hide an image. Untagged media is shared and stays
       visible for every device. */
    var devicePos = parseInt(root.dataset.devicePos, 10);
    var deviceFilterOn = root.dataset.deviceFilter === 'true' && devicePos >= 0;
    var deviceTitleOn = root.dataset.deviceTitle === 'true' && devicePos >= 0;
    var knownDevices = {};
    if (devicePos >= 0) {
      variants.forEach(function (v) { knownDevices[v.options[devicePos]] = true; });
    }
    var MEDIA_SELECTORS = '.vpdp__feature-item, .vpdp__tile, .vpdp__carousel-slide, .vpdp__lb-item, .vpdp__dot';

    /* One image can serve several devices: a dual-fit SKU fits two phones and
       has a single photo, tagged "iPhone 16 Pro, iPhone 16 Pro Max: ...". The
       tag is honoured only when every entry is a real Device value, so a
       supplier alt that merely contains a colon can never hide an image. */
    function deviceTagOf(el) {
      var raw = el.getAttribute('data-device');
      if (!raw) return null;
      var parts = raw.split(',').map(function (t) { return t.trim(); });
      var ok = parts.length && parts.every(function (t) { return knownDevices[t]; });
      return ok ? parts : null;
    }
    function visibleLb() {
      var out = [];
      lbItems.forEach(function (el, i) { if (!el.hidden) out.push(i); });
      return out;
    }
    function applyDeviceFilter(device) {
      if (!deviceFilterOn || !device) return;
      root.querySelectorAll(MEDIA_SELECTORS).forEach(function (el) {
        var tag = deviceTagOf(el);
        el.hidden = !!(tag && tag.indexOf(device) === -1);
      });
      var vis = visibleLb();
      var first = vis.length ? vis[0] : 0;
      lbIdx = first;
      setFeature(first);
      scrollCarouselTo(first);
    }

    var titleEl = refs.title;
    /* Keep whatever the tag line appends after the product name (" - Shop"),
       but only when document.title actually starts with the product title.
       Shopify serves a truncated SEO title here, so a blind replace() matches
       nothing and leaves the whole original to be appended twice. */
    var titleSuffix = '';
    if (root.dataset.productTitle && document.title.indexOf(root.dataset.productTitle) === 0) {
      titleSuffix = document.title.slice(root.dataset.productTitle.length);
    }
    function applyDeviceTitle(device) {
      if (!deviceTitleOn || !titleEl || !device) return;
      var family = titleEl.dataset.titleFamily;
      var diff = titleEl.dataset.titleDiff;
      if (!family) return;
      var t = family + ' for ' + device + (diff ? ' | ' + diff : '');
      titleEl.textContent = t;
      document.title = t + titleSuffix;
    }

    function setFeature(idx) {
      featureItems.forEach(function (el, i) { el.classList.toggle('is-active', i === idx); });
    }

    var zoomScale = 1, zoomX = 0, zoomY = 0;
    function activeLbImg() {
      var item = lbItems[lbIdx];
      return item ? item.querySelector('.vpdp__lb-img') : null;
    }
    function applyZoom() {
      var img = activeLbImg();
      if (!img) return;
      img.style.transform = zoomScale > 1 ? 'translate(' + zoomX + 'px,' + zoomY + 'px) scale(' + zoomScale + ')' : '';
      lightbox.classList.toggle('is-zoomed', zoomScale > 1);
    }
    function resetZoom() { zoomScale = 1; zoomX = 0; zoomY = 0; applyZoom(); }

    /* idx is an absolute media position. Filtering leaves gaps in that
       sequence, so counting and stepping both run over the visible subset —
       otherwise the arrows walk into hidden images and the counter lies. */
    function showLb(idx) {
      var vis = visibleLb();
      if (!vis.length) return;
      var at = vis.indexOf(idx);
      if (at < 0) { at = 0; idx = vis[0]; }
      lbIdx = idx;
      resetZoom();
      lbItems.forEach(function (el, i) {
        el.classList.toggle('is-active', i === lbIdx);
        var vid = el.querySelector('video');
        if (vid && i !== lbIdx) vid.pause();
      });
      if (refs.lbCount) refs.lbCount.textContent = (at + 1) + ' / ' + vis.length;
    }
    function stepLb(delta) {
      var vis = visibleLb();
      if (!vis.length) return;
      var at = vis.indexOf(lbIdx);
      if (at < 0) at = 0;
      showLb(vis[(at + delta + vis.length) % vis.length]);
    }
    function openLb(idx) {
      trackEvent('media_engage', { media_position: idx + 1, media_count: mediaCount, type: 'lightbox_open' });
      if (!lightbox) return;
      showLb(idx);
      lightbox.showModal();
    }

    if (refs.featureZoom) refs.featureZoom.addEventListener('click', function () {
      var active = root.querySelector('.vpdp__feature-item.is-active');
      openLb(active ? parseInt(active.dataset.idx, 10) : 0);
    });
    root.querySelectorAll('.vpdp__tile, .vpdp__carousel-slide').forEach(function (btn) {
      btn.addEventListener('click', function () { openLb(parseInt(btn.dataset.idx, 10)); });
    });
    if (lightbox) {
      if (refs.lbClose) refs.lbClose.addEventListener('click', function () { lightbox.close(); });
      if (refs.lbPrev) refs.lbPrev.addEventListener('click', function () { stepLb(-1); });
      if (refs.lbNext) refs.lbNext.addEventListener('click', function () { stepLb(1); });
      lightbox.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') stepLb(-1);
        if (e.key === 'ArrowRight') stepLb(1);
      });
      lightbox.addEventListener('close', function () {
        lbItems.forEach(function (el) {
          var vid = el.querySelector('video');
          if (vid) vid.pause();
        });
        resetZoom();
      });

      var stage = refs.lbStage;
      var pointers = new Map();
      var pinchStartDist = 0, pinchStartScale = 1;
      function dist() {
        var p = Array.from(pointers.values());
        return Math.hypot(p[0].x - p[1].x, p[0].y - p[1].y);
      }
      stage.addEventListener('pointerdown', function (e) {
        pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });
        if (pointers.size === 2) { pinchStartDist = dist(); pinchStartScale = zoomScale; }
      });
      stage.addEventListener('pointermove', function (e) {
        if (!pointers.has(e.pointerId)) return;
        var prev = pointers.get(e.pointerId);
        pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });
        if (pointers.size === 2) {
          zoomScale = Math.min(4, Math.max(1, pinchStartScale * (dist() / pinchStartDist)));
          applyZoom();
        } else if (pointers.size === 1 && zoomScale > 1) {
          zoomX += e.clientX - prev.x;
          zoomY += e.clientY - prev.y;
          applyZoom();
        }
      });
      ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (evt) {
        stage.addEventListener(evt, function (e) { pointers.delete(e.pointerId); });
      });
      stage.addEventListener('click', function (e) {
        if (pointers.size > 0) return;
        var img = activeLbImg();
        if (!img || !img.contains(e.target)) return;
        if (zoomScale > 1) { resetZoom(); return; }
        zoomScale = 2.4;
        var r = img.getBoundingClientRect();
        zoomX = (r.left + r.width / 2 - e.clientX) * (zoomScale - 1);
        zoomY = (r.top + r.height / 2 - e.clientY) * (zoomScale - 1);
        applyZoom();
      });
    }

    /* ── Mobile carousel dots ── */
    var track = refs.carouselTrack;
    var dots = refs.dots ? refs.dots.querySelectorAll('.vpdp__dot') : [];
    if (track && dots.length) {
      var dotTick = false;
      track.addEventListener('scroll', function () {
        if (dotTick) return;
        dotTick = true;
        requestAnimationFrame(function () {
          dotTick = false;
          var idx = Math.round(track.scrollLeft / track.clientWidth);
          dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
        });
      }, { passive: true });
    }
    function scrollCarouselTo(idx) {
      if (track) track.scrollTo({ left: idx * track.clientWidth, behavior: reduceMotion ? 'auto' : 'smooth' });
    }

    /* ── Variant engine ── */
    var form = refs.form || document.getElementById('vpdp-form-' + id);
    var vidInput = refs.variantId;
    var activeVariant = variants.find(function (v) { return String(v.id) === (vidInput ? vidInput.value : ''); }) || variants[0];
    /* updateUI() only runs on option change, not on initial load, so the
       delivered total has to be rendered here or it stays blank until the
       shopper touches a variant option. selectedTier is already set by the
       preselect IIFE above; activeVariant only becomes usable here. */
    updateShipTotal();
    var selectedOpts = activeVariant ? activeVariant.options.slice() : [];

    function findVariant(opts) {
      opts = opts || selectedOpts;
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }
    function valueHasVariant(pos, val) {
      return variants.some(function (v) {
        return v.options.every(function (o, i) { return i === pos ? o === val : o === selectedOpts[i]; });
      });
    }

    function syncInputs() {
      root.querySelectorAll('input[type="radio"][data-pos]').forEach(function (input) {
        var pos = parseInt(input.dataset.pos, 10);
        input.checked = input.value === selectedOpts[pos];
        input.disabled = !valueHasVariant(pos, input.value);
        /* On a merged device product the colour list is the union across every
           device, so one phone shows its own colours plus a dozen struck-through
           ones it cannot have. The shopper has already named their device, so
           hide those instead of crossing them out. Only the non-device options
           are hidden, and only when the gallery is device-scoped, so ordinary
           products keep the standard sold-out styling. */
        if (deviceFilterOn && pos !== devicePos) {
          var swatch = input.closest('.vpdp__swatch') || input.parentElement;
          if (swatch) swatch.hidden = input.disabled;
        }
      });
      arr(refs.optionSelect).forEach(function (sel) {
        sel.value = selectedOpts[parseInt(sel.dataset.pos, 10)];
      });
    }

    /* The big price shows the DELIVERED total, not the bare variant price, so
       a shopper who picked Instant Ship sees one number and it is the number
       they pay. The compare-at and the percentage badge stay keyed to the bare
       prices: discounting is a property of the goods, and folding an upgrade
       fee into it would advertise a saving that does not exist. */
    function priceHTML(v) {
      var fee = feeFor(selectedTier);
      var html = '<span class="vpdp__price-now">' + money(v.price + fee) + '</span>';
      if (v.compare_at_price && v.compare_at_price > v.price) {
        html += '<s class="vpdp__price-was">' + money(v.compare_at_price + fee) + '</s>';
        var pctMode = root.dataset.pct;
        if (pctMode && pctMode !== 'off') {
          var pct = ((v.compare_at_price - v.price) / v.compare_at_price) * 100;
          pct = pctMode === 'floor' ? Math.floor(pct) : Math.round(pct);
          if (pct >= 1) {
            html += '<span class="vpdp__price-pct">' + pct + '% ' + (root.dataset.pctLabel || 'Off') + '</span>';
          }
        }
      }
      if (fee > 0 && selectedTier) {
        html += '<span class="vpdp__price-tier">with ' + selectedTier.name + '</span>';
      }
      return html;
    }

    function updateUI(v) {
      if (!v) {
        [refs.atc, refs.barAtc].forEach(function (b) { if (b) { b.disabled = true; b.setAttribute('aria-disabled', 'true'); } });
        [refs.atcLabel, refs.barAtcLabel].forEach(function (l) { if (l) l.textContent = 'Unavailable'; });
        announce('Selected combination is unavailable');
        return;
      }
      activeVariant = v;
      if (vidInput) vidInput.value = v.id;
      /* updateShipTotal owns both the big price and the sticky-bar price, so
         that a tier change and a variant change render through one path. */
      if (refs.price) refs.price.innerHTML = priceHTML(v);
      if (refs.barPrice) refs.barPrice.textContent = money(deliveredPrice(v));
      updateShipTotal();
      [refs.atc, refs.barAtc].forEach(function (b) {
        if (b) { b.disabled = !v.available; b.setAttribute('aria-disabled', String(!v.available)); }
      });
      [refs.atcLabel, refs.barAtcLabel].forEach(function (l) {
        if (l) l.textContent = v.available ? 'Add to cart' : 'Sold out';
      });
      /* ponytail: button price is the selected variant, not a bundle-inclusive total —
         bundle discounts are applied as codes at checkout, so a "final total" here would lie. */
      if (refs.atcPrice) refs.atcPrice.textContent = v.available ? money(v.price) : '';
      if (refs.sku) refs.sku.textContent = v.sku || root.dataset.productId;
      var u = new URL(window.location.href);
      u.searchParams.set('variant', v.id);
      history.replaceState({}, '', u.toString());
      if (v.featured_image && v.featured_image.position) {
        setFeature(v.featured_image.position - 1);
        scrollCarouselTo(v.featured_image.position - 1);
      }
      if (devicePos >= 0) {
        applyDeviceTitle(v.options[devicePos]);
        applyDeviceFilter(v.options[devicePos]);
      }
      announce(v.title + ', ' + money(v.price) + (v.available ? '' : ', sold out'));
      /* Lets variant-aware sections below the fold (e.g. the O3 colour explorer) mirror the
         real selection instead of keeping a second, driftable copy of the variant state. */
      document.dispatchEvent(new CustomEvent('vpdp:variant', {
        detail: { sectionId: id, variant: v, options: selectedOpts.slice(), optionNames: optionNames }
      }));
    }

    function onOptionChange(pos, val) {
      selectedOpts[pos] = val;
      if (!findVariant()) {
        var fallback = variants.find(function (v) { return v.options[pos] === val; });
        if (fallback) selectedOpts = fallback.options.slice();
      }
      syncInputs();
      var picked = findVariant();
      updateUI(picked);
      trackEvent('variant_select', {
        option: optionNames[pos] || 'option_' + pos,
        value: val,
        available: !!(picked && picked.available)
      });
    }

    if (deviceFilterOn && activeVariant) {
      applyDeviceFilter(activeVariant.options[devicePos]);
    }

    root.querySelectorAll('input[type="radio"][data-pos]').forEach(function (input) {
      input.addEventListener('change', function () {
        onOptionChange(parseInt(input.dataset.pos, 10), input.value);
      });
    });
    arr(refs.optionSelect).forEach(function (sel) {
      sel.addEventListener('change', function () {
        onOptionChange(parseInt(sel.dataset.pos, 10), sel.value);
      });
    });

    if ('requestIdleCallback' in window) {
      requestIdleCallback(function () {
        variants.forEach(function (v) {
          if (v.featured_image && v.featured_image.src) {
            new Image().src = v.featured_image.src + (v.featured_image.src.indexOf('?') > -1 ? '&' : '?') + 'width=1400';
          }
        });
      });
    }

    /* ── Analytics ──
       PostHog is loaded by the PixieHog app, GTM by the theme; both may be absent
       (ad blockers, consent tools), so every call is guarded and never throws. */
    function trackEvent(name, props) {
      var base = {
        product_id: root.dataset.productId,
        product_title: root.dataset.productTitle,
        variant_id: activeVariant ? String(activeVariant.id) : null,
        variant_title: activeVariant ? activeVariant.title : null,
        price: activeVariant ? activeVariant.price / 100 : null,
        currency: root.dataset.currency,
        viewport: window.innerWidth < 750 ? 'mobile' : 'desktop'
      };
      var payload = Object.assign(base, props || {});
      try {
        if (window.posthog && typeof window.posthog.capture === 'function') {
          window.posthog.capture(name, payload);
        }
        (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, payload));
      } catch (e) { /* analytics must never break the buy flow */ }
    }

    /* ── Add to cart (AJAX, reuses theme cart events) ── */
    /* items: [{ id, quantity, properties? }] — one request, so a failure adds nothing */
    function addToCart(items, btn, sourceId) {
      if (btn && btn.classList.contains('is-loading')) return Promise.resolve(false);
      if (btn) btn.classList.add('is-loading');
      var sectionIds = [];
      document.querySelectorAll('cart-items-component').forEach(function (el) {
        if (el.dataset.sectionId) sectionIds.push(el.dataset.sectionId);
      });
      var payload = { items: items };
      if (sectionIds.length) payload.sections = sectionIds.join(',');
      var addUrl = (window.Theme && Theme.routes && Theme.routes.cart_add_url) || '/cart/add.js';
      return fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (r) { return r.json(); })
        .then(function (resp) {
          if (resp.status) {
            announce(resp.description || resp.message || 'Could not add to cart');
            trackEvent('add_to_cart_error', { error_type: resp.description || resp.message || 'unknown', source: sourceId });
            return false;
          }
          trackEvent('pdp_add_to_cart', {
            quantity: items.reduce(function (n, it) { return n + (it.quantity || 1); }, 0),
            line_items: items.length,
            bundle_items: Math.max(0, items.length - 1),
            source: sourceId
          });
          return fetch('/cart.js')
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              root.dispatchEvent(new CustomEvent('cart:update', {
                bubbles: true,
                detail: {
                  resource: cart,
                  sourceId: sourceId,
                  data: {
                    source: 'product-form-component',
                    /* The shipping upgrade is not a product. Counting it here
                       makes the header bubble read one higher than the cart
                       drawer, which counts goods only. */
                    itemCount: items.reduce(function (n, it) {
                      var role = it.properties && it.properties._vg_role;
                      if (role === 'shipping_upgrade') return n;
                      return n + (it.quantity || 1);
                    }, 0),
                    productId: root.dataset.productId,
                    variantId: String(items[0].id),
                    sections: resp.sections
                  }
                }
              }));
              // Explicitly open the refreshed drawer so the sticky/primary CTA
              // never depends on the merchant's auto_open_cart_drawer setting.
              // The cart:update dispatch above has already morphed the drawer
              // section, so the content is non-stale before it opens.
              var drawer = document.querySelector('cart-drawer-component');
              if (drawer && typeof drawer.open === 'function') {
                try { drawer.open(); } catch (e) { /* drawer optional */ }
              }
              announce('Added to cart');
              return true;
            });
        })
        .catch(function () {
          announce('Could not add to cart. Please try again.');
          trackEvent('add_to_cart_error', { error_type: 'network', source: sourceId });
          return false;
        })
        .finally(function () {
          if (btn) btn.classList.remove('is-loading');
        });
    }

    /* ── Bundle & Save ── */
    var bundleStates = [];
    var bundleEl = refs.bundle;
    var updateBundle = function () {};
    if (bundleEl) {
      var bundleDataEl = document.getElementById('vbs-data-' + id);
      var bundleData = [];
      try { bundleData = JSON.parse(bundleDataEl.textContent); } catch (e) { bundleData = []; }
      var bundleTiers = [
        { offer: 'Add 1, Save 5%', msg: 'Add 1 accessory to save 5%.', fill: 0, now: 0, text: 'No bundle discount unlocked', pct: 0 },
        { offer: 'Add 2, Save 10%', msg: 'You added 1 accessory. Add 1 more to save 10%!', fill: 0.5, now: 5, text: '5% bundle discount unlocked', pct: 5 },
        { offer: 'Bundle complete: Save 10%', msg: 'You added 2 accessories and unlocked 10% off!', fill: 1, now: 10, text: '10% bundle discount unlocked', pct: 10 }
      ];

      function swapText(el, text) {
        if (!el || el.textContent === text) return;
        el.textContent = text;
        if (!reduceMotion && el.animate) {
          el.animate(
            [{ opacity: 0, transform: 'translateY(4px)' }, { opacity: 1, transform: 'none' }],
            { duration: 250, easing: 'ease-out' }
          );
        }
      }

      bundleEl.querySelectorAll('[data-vbs-item]').forEach(function (row) {
        var pid = parseInt(row.dataset.productId, 10);
        var data = null;
        bundleData.forEach(function (d) { if (d.productId === pid) data = d; });
        if (!data) return;
        var sel = row.querySelector('[data-vbs-variant]');
        var pickVariant = function () {
          var vid = sel ? parseInt(sel.value, 10) : 0;
          var match = null;
          data.variants.forEach(function (v) {
            if (sel ? v.id === vid : (!match && v.available)) match = v;
          });
          return match || data.variants[0];
        };
        var state = {
          row: row,
          qty: 0,
          soldout: !data.available,
          variant: pickVariant(),
          els: {
            minus: row.querySelector('[data-vbs-minus]'),
            plus: row.querySelector('[data-vbs-plus]'),
            count: row.querySelector('[data-vbs-count]'),
            price: row.querySelector('[data-vbs-price]'),
            compare: row.querySelector('[data-vbs-compare]'),
            deal: row.querySelector('[data-vbs-deal]'),
            img: row.querySelector('.vbs__img'),
            added: row.querySelector('[data-vbs-added]')
          }
        };
        bundleStates.push(state);

        state.els.plus.addEventListener('click', function () {
          if (state.qty >= 1 || state.soldout) return;
          state.qty = 1;
          updateBundle(true);
        });
        state.els.minus.addEventListener('click', function () {
          if (state.qty === 0) return;
          state.qty = 0;
          updateBundle(true);
        });
        if (sel) {
          sel.addEventListener('change', function () {
            state.variant = pickVariant();
            if (state.els.price) state.els.price.textContent = money(state.variant.price);
            if (state.els.compare) {
              var cmp = state.variant.compare_at_price;
              state.els.compare.hidden = !(cmp && cmp > state.variant.price);
              if (!state.els.compare.hidden) state.els.compare.textContent = money(cmp);
            }
            if (state.els.img && state.variant.featured_image && state.variant.featured_image.src) {
              state.els.img.src = state.variant.featured_image.src;
              state.els.img.removeAttribute('srcset');
            }
            updateBundle(false);
          });
        }
      });

      updateBundle = function (announceChange) {
        var count = 0;
        bundleStates.forEach(function (s) { if (s.qty > 0 && !s.soldout) count = count + 1; });
        var tier = bundleTiers[Math.min(count, 2)];
        swapText(refs.bundleOffer, tier.offer);
        swapText(refs.bundleMsg, tier.msg);
        if (refs.bundleFill) refs.bundleFill.style.transform = 'scaleX(' + tier.fill + ')';
        if (refs.bundleBar) {
          refs.bundleBar.setAttribute('aria-valuenow', String(tier.now));
          refs.bundleBar.setAttribute('aria-valuetext', tier.text);
        }
        if (refs.bundleTick5) refs.bundleTick5.classList.toggle('is-unlocked', count >= 1);
        if (refs.bundleTick10) refs.bundleTick10.classList.toggle('is-unlocked', count >= 2);
        if (refs.bundleBadge) refs.bundleBadge.classList.toggle('is-on', count >= 2);
        bundleStates.forEach(function (s) {
          var selected = s.qty > 0 && !s.soldout;
          s.row.classList.toggle('is-selected', selected);
          if (s.els.count) s.els.count.textContent = String(s.qty);
          if (s.els.added) s.els.added.hidden = !selected;
          if (s.els.minus) s.els.minus.disabled = s.qty === 0;
          if (s.els.plus) s.els.plus.disabled = s.qty >= 1 || s.soldout;
          if (s.els.deal && s.els.price) {
            if (selected && tier.pct > 0) {
              s.els.deal.hidden = false;
              s.els.deal.textContent = money(Math.round(s.variant.price * (1 - tier.pct / 100))) + ' in bundle';
              s.els.price.classList.add('is-struck');
            } else {
              s.els.deal.hidden = true;
              s.els.price.classList.remove('is-struck');
            }
          }
        });
        if (announceChange) announce(tier.text + '. ' + tier.msg);
      };
      updateBundle(false);
    }

    function buildCartItems() {
      var items = [{ id: activeVariant.id, quantity: 1 }];
      var selected = bundleStates.filter(function (s) { return s.qty > 0 && !s.soldout && s.variant && s.variant.available; });
      if (selected.length) {
        var bid = 'vgb-' + Date.now();
        var tierName = selected.length >= 2 ? '10' : '5';
        items[0].properties = { _vg_role: 'case', _vg_bundle: bid, _vg_tier: tierName };
        selected.forEach(function (s) {
          items.push({
            id: s.variant.id,
            quantity: 1,
            properties: { _vg_role: 'accessory', _vg_bundle: bid, _vg_tier: tierName, _vg_parent: String(activeVariant.id) }
          });
        });
      }
      /* Merge, don't overwrite: the bundle branch above may already have set
         items[0].properties, and clobbering it here would drop _vg_bundle. */
      if (selectedTier) {
        items[0].properties = items[0].properties || {};
        items[0].properties['Requested shipping'] = selectedTier.name;
      }

      /* The Instant Ship upgrade is a line item because Shopify holds money in
         line items and delivery rates, and the Instant RATE has been removed:
         this is the only place the upgrade can be charged. It is added only
         when the tier actually costs something, so a product whose price
         already paid for Instant never gets a second charge.

         _vg_role marks it for the cart drawer, which folds it into the summary
         rather than listing it as a product, and for the hygiene pass that
         removes it when its parent leaves the cart. */
      var upgradeId = parseInt((refs.shipTiers && refs.shipTiers.dataset.upgradeVariant) || '', 10);
      if (selectedTier && feeFor(selectedTier) > 0 && upgradeId) {
        items.push({
          id: upgradeId,
          quantity: 1,
          properties: {
            _vg_role: 'shipping_upgrade',
            _vg_parent: String(activeVariant.id),
            'Shipping method': selectedTier.name
          }
        });
      }
      return items;
    }

    function resetBundle() {
      if (!bundleStates.length) return;
      bundleStates.forEach(function (s) { s.qty = 0; });
      updateBundle(false);
    }

    function submitMain(btn, sourceId) {
      if (!activeVariant || !activeVariant.available) return;
      var items = buildCartItems();
      addToCart(items, btn, sourceId).then(function (ok) {
        if (ok && items.length > 1) resetBundle();
      });
    }
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        submitMain(refs.atc, form.id);
      });
    }
    if (refs.barAtc) {
      refs.barAtc.addEventListener('click', function () {
        var depth = document.documentElement.scrollHeight - window.innerHeight;
        trackEvent('sticky_cta_click', {
          scroll_depth_pct: depth > 0 ? Math.round((window.scrollY / depth) * 100) : 0
        });
        submitMain(refs.barAtc, form ? form.id : id);
      });
    }
    arr(refs.stackAdd).forEach(function (btn) {
      btn.addEventListener('click', function () {
        addToCart([{ id: parseInt(btn.dataset.variantId, 10), quantity: 1 }], btn, id).then(function (ok) {
          if (!ok) return;
          btn.classList.add('is-added');
          var label = btn.querySelector('span');
          if (label) label.textContent = 'Added';
          setTimeout(function () {
            btn.classList.remove('is-added');
            if (label) label.textContent = 'Add';
          }, 2000);
        });
      });
    });

    /* ── Delivery checker ── */
    /* ponytail: local pincode validation + configured ETA only; swap in a real
       serviceability API call here when the store has one */
    if (refs.pinCheck && refs.pinInput) {
      function showPinMsg(text, cls) {
        refs.pinMsg.hidden = false;
        refs.pinMsg.className = 'vpdp__delivery-msg ' + cls;
        refs.pinMsg.textContent = text;
      }
      function checkPin() {
        var pin = refs.pinInput.value.trim();
        if (!/^[1-9][0-9]{5}$/.test(pin)) {
          showPinMsg('Please enter a valid 6-digit pincode.', 'is-error');
          return;
        }
        refs.pinCheck.disabled = true;
        showPinMsg('Checking availability…', '');
        setTimeout(function () {
          refs.pinCheck.disabled = false;
          var min = parseInt(root.dataset.deliveryMin, 10) || 2;
          var max = parseInt(root.dataset.deliveryMax, 10) || 5;
          var fmtDate = function (days) {
            var d = new Date();
            d.setDate(d.getDate() + days);
            return d.toLocaleDateString(undefined, { weekday: 'short', day: 'numeric', month: 'short' });
          };
          var msg = 'Delivery to ' + pin + ' by ' + fmtDate(min) + ' – ' + fmtDate(max) + '.';
          if (root.dataset.cod === 'true') msg += ' Cash on delivery available.';
          showPinMsg(msg, 'is-success');
          announce(msg);
        }, 500);
      }
      refs.pinCheck.addEventListener('click', checkPin);
      refs.pinInput.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); checkPin(); }
      });
    }

    /* ── Analytics wiring for disclosures, bundle and first view ── */
    root.querySelectorAll('.vpdp__acc').forEach(function (acc) {
      acc.addEventListener('toggle', function () {
        if (!acc.open) return;
        var label = acc.querySelector('summary span');
        trackEvent('proof_expand', { module: 'buy_box_accordion', question: label ? label.textContent.trim() : '' });
      });
    });

    if (bundleEl) {
      var bundleDetails = bundleEl.closest('details') || bundleEl.querySelector('details');
      if (bundleDetails) {
        bundleDetails.addEventListener('toggle', function () {
          if (bundleDetails.open) trackEvent('bundle_open', { position: 'below_cta' });
        });
      } else {
        /* bundle renders open — count the first interaction as the open signal */
        var bundleSeen = false;
        bundleEl.addEventListener('click', function () {
          if (bundleSeen) return;
          bundleSeen = true;
          trackEvent('bundle_open', { position: 'below_cta' });
        }, true);
      }
      bundleEl.querySelectorAll('[data-vbs-plus]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var row = btn.closest('[data-vbs-item]');
          var state = bundleStates.find(function (s) { return s.row === row; });
          trackEvent('bundle_select', {
            accessory_product_id: row ? row.dataset.productId : null,
            accessory_variant_id: state && state.variant ? String(state.variant.id) : null,
            incremental_price: state && state.variant ? state.variant.price / 100 : null
          });
        });
      });
    }

    trackEvent('pdp_view', {
      template: root.dataset.template,
      media_count: mediaCount,
      has_bundle: !!bundleEl
    });

    /* ── Gift dialog ── */
    if (refs.giftLearn && refs.giftDialog) {
      refs.giftLearn.addEventListener('click', function () { refs.giftDialog.showModal(); });
      if (refs.giftClose) refs.giftClose.addEventListener('click', function () { refs.giftDialog.close(); });
      refs.giftDialog.addEventListener('click', function (e) {
        if (e.target === refs.giftDialog) refs.giftDialog.close();
      });
    }

    /* ── Reviews scroll ── */
    if (refs.reviewsLink) {
      refs.reviewsLink.addEventListener('click', function () {
        var target = document.querySelector('.vtm') || document.querySelector('[id*="testimonials"]');
        if (target) target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth' });
      });
    }

    /* ── Sticky panel top (lets tall panels scroll before sticking) ── */
    var panel = refs.panel;
    if (panel && 'ResizeObserver' in window) {
      var setStickyTop = function () {
        var header = parseFloat(getComputedStyle(document.body).getPropertyValue('--header-height')) || 60;
        panel.style.top = Math.min(header + 24, window.innerHeight - panel.offsetHeight - 24) + 'px';
      };
      new ResizeObserver(setStickyTop).observe(panel);
      window.addEventListener('resize', setStickyTop);
      setStickyTop();
    }

    /* ── Mobile sticky bar ── */
    if (refs.atc && refs.stickyBar && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        /* Show whenever the main ATC is off-screen in EITHER direction. The old
           `&& boundingClientRect.top < 0` limited this to "user has scrolled past
           the button", so on mobile — where the ATC sits ~1150px down — the bar
           stayed hidden for the entire approach and only appeared once the buyer
           had already skipped the real button. */
        var visible = !e.isIntersecting;
        refs.stickyBar.classList.toggle('is-visible', visible);
        /* Shared offset flag: lets the back-to-top control and the app-injected
           chat launcher lift above the sticky purchase bar (brief 4.3). The chat
           widget is not part of the theme, so a body-class + global CSS hook is
           the only theme-side lever available. */
        document.body.classList.toggle('vpdp-sticky-on', visible);
      }).observe(refs.atc);
    }

    /* ── Back to top ── */
    if (refs.backToTop) {
      var topTick = false;
      window.addEventListener('scroll', function () {
        if (topTick) return;
        topTick = true;
        requestAnimationFrame(function () {
          topTick = false;
          refs.backToTop.classList.toggle('is-visible', window.scrollY > 500);
        });
      }, { passive: true });
      refs.backToTop.addEventListener('click', function () {
        window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
      });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vantage-q3-anatomy"] && !Shopify.designMode) return;
  try {
    
// Cross-links a layer row to its marker. Purely additive: every row already carries its
// own number and copy, so with this script absent the figure is still a labelled diagram.
document.querySelectorAll('[data-q3-anatomy]').forEach((stage) => {
  const layers = stage.querySelectorAll('[data-q3-layer]');
  const markers = stage.querySelectorAll('[data-q3-marker]');
  if (!layers.length || !markers.length) return;

  const setActive = (n) => {
    layers.forEach((l) => l.classList.toggle('is-active', l.dataset.q3Layer === n));
    markers.forEach((m) => m.classList.toggle('is-active', m.dataset.q3Marker === n));
  };

  layers.forEach((layer) => {
    const n = layer.dataset.q3Layer;
    layer.addEventListener('pointerenter', () => setActive(n));
    layer.addEventListener('focus', () => setActive(n));
    layer.addEventListener('pointerleave', () => setActive(null));
    layer.addEventListener('blur', () => setActive(null));
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vantage-q3-ostand"] && !Shopify.designMode) return;
  try {
    
// Upgrades the column of stills into a single crossfading stage. The class is only added
// once the controls are wired, so a script failure leaves the readable stills in place.
document.querySelectorAll('[data-q3-ostand]').forEach((stage) => {
  const buttons = stage.querySelectorAll('[data-q3-step]');
  const frames = stage.querySelectorAll('[data-q3-frame]');
  if (buttons.length < 2 || frames.length < 2) return;

  const select = (n) => {
    buttons.forEach((b) => {
      const on = b.dataset.q3Step === n;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    frames.forEach((f) => f.classList.toggle('is-active', f.dataset.q3Frame === n));
  };

  buttons.forEach((button) => {
    button.addEventListener('click', () => select(button.dataset.q3Step));
  });

  stage.closest('.q3os').classList.add('q3os--js');
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vantage-story"] && !Shopify.designMode) return;
  try {
    
/* Reveal on scroll. IntersectionObserver only — no scroll listeners. If the browser
   lacks IO, everything is shown immediately rather than left invisible. */
(function () {
  var targets = document.querySelectorAll('[data-vst-reveal]');
  if (!targets.length) return;

  if (!('IntersectionObserver' in window)) {
    targets.forEach(function (el) { el.classList.add('is-in'); });
    return;
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-in');
      io.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -12% 0px', threshold: 0.15 });

  targets.forEach(function (el) { io.observe(el); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vantage-svg-brand-reveal"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const clamp = (value, min = 0, max = 1) => Math.min(max, Math.max(min, value));
    const smooth = (value) => {
      const t = clamp(value);
      return t * t * (3 - 2 * t);
    };
    const backOut = (value) => {
      const t = clamp(value);
      const c1 = 1.70158;
      const c3 = c1 + 1;
      return 1 + c3 * Math.pow(t - 1, 3) + c1 * Math.pow(t - 1, 2);
    };

    const setup = (root) => {
      if (root.dataset.vantageReady === 'true') return;
      root.dataset.vantageReady = 'true';
      root.classList.add('is-enhanced');

      const sticky = root.querySelector('.vantage-svg-reveal__sticky');
      const stage = root.querySelector('.vantage-svg-reveal__stage');
      const box = root.querySelector('[data-vantage-box]');
      const rear = root.querySelector('[data-vantage-rear-flap]');
      const left = root.querySelector('[data-vantage-left-flap]');
      const right = root.querySelector('[data-vantage-right-flap]');
      const front = root.querySelector('[data-vantage-front-flap]');
      const lid = root.querySelector('[data-vantage-closed-lid]');
      const glow = root.querySelector('[data-vantage-glow]');
      const particles = root.querySelector('[data-vantage-particles]');
      const brands = [...root.querySelectorAll('[data-vantage-brand]')];
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      let frame = 0;
      let current = reduceMotion ? 1 : 0;

      const render = () => {
        frame = 0;
        const rect = root.getBoundingClientRect();
        const travel = Math.max(root.offsetHeight - window.innerHeight, 1);
        const target = reduceMotion ? 1 : clamp(-rect.top / travel);
        current += (target - current) * (reduceMotion ? 1 : 0.16);
        if (Math.abs(target - current) > 0.0008) request();

        const opening = smooth((current - 0.035) / 0.2);
        const energy = Math.sin(Math.PI * clamp((current - 0.02) / 0.28));

        lid.style.opacity = String(1 - opening);
        lid.style.transform = `translateY(${-18 * opening}px) scaleY(${1 - opening * 0.08})`;
        rear.style.opacity = String(0.12 + opening * 0.88);
        rear.style.transform = `translateY(${92 * (1 - opening)}px) scaleY(${0.18 + opening * 0.82})`;
        left.style.opacity = String(opening);
        left.style.transform = `translate(${34 * (1 - opening)}px, ${-12 * opening}px) rotate(${18 * (1 - opening)}deg)`;
        right.style.opacity = String(opening);
        right.style.transform = `translate(${-34 * (1 - opening)}px, ${-12 * opening}px) rotate(${-18 * (1 - opening)}deg)`;
        front.style.opacity = String(opening);
        front.style.transform = `translateY(${-34 * (1 - opening)}px) scaleY(${0.3 + opening * 0.7})`;
        glow.style.opacity = String(opening * 0.92);
        particles.style.opacity = String(clamp(opening * 1.4 - 0.25) * (1 - clamp((current - 0.82) / 0.18)));
        box.style.transform = `translateX(-50%) translateY(${energy * -5}px) scale(${1 + energy * 0.012})`;

        const stageRect = stage.getBoundingClientRect();
        brands.forEach((brand) => {
          const order = Number(brand.dataset.order || 1);
          const scaleTarget = Number(brand.dataset.scale || 100) / 100;
          const rotation = Number(brand.dataset.rotation || 0);
          const start = 0.22 + (order - 1) * 0.045;
          const localRaw = clamp((current - start) / 0.19);
          const local = backOut(localRaw);
          const layoutX = stageRect.left + stageRect.width * (parseFloat(brand.style.left) / 100);
          const layoutY = stageRect.top + stageRect.height * (parseFloat(brand.style.top) / 100);
          const boxMouthX = stageRect.left + stageRect.width * 0.5;
          const boxMouthY = stageRect.top + stageRect.height * 0.62;
          const startX = boxMouthX - layoutX;
          const startY = boxMouthY - layoutY;
          const arc = Math.sin(Math.PI * localRaw) * -58;
          const sideSway = Math.sin(Math.PI * localRaw) * (order % 2 === 0 ? -16 : 16);
          const x = startX * (1 - local) + sideSway;
          const y = startY * (1 - local) + arc;
          const scale = 0.16 + (scaleTarget - 0.16) * local;
          const spin = rotation * local + (1 - localRaw) * (order % 2 === 0 ? -8 : 8);

          brand.style.opacity = String(smooth(localRaw * 1.8));
          brand.style.transform = `translate(calc(-50% + ${x}px), calc(-50% + ${y}px)) rotate(${spin}deg) scale(${scale})`;
          brand.style.filter = `drop-shadow(0 ${8 + local * 10}px ${8 + local * 10}px rgba(0,0,0,${0.08 + local * 0.1}))`;
        });

        root.classList.toggle('is-settled', current > 0.96);
      };

      const request = () => {
        if (!frame) frame = window.requestAnimationFrame(render);
      };

      window.addEventListener('scroll', request, { passive: true });
      window.addEventListener('resize', request, { passive: true });
      document.addEventListener('shopify:block:select', request);
      request();
    };

    const initialize = () => document.querySelectorAll('[data-vantage-svg-reveal]').forEach(setup);
    initialize();
    document.addEventListener('shopify:section:load', initialize);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vantage-whatsapp-float"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('[data-vwa]');
  if (!root) return;
  var KEY = 'vwa-bubble-off';
  var off = function () { try { return sessionStorage.getItem(KEY) === '1'; } catch (e) { return false; } };
  if (off()) return;

  var first = (+root.dataset.first || 3.5) * 1000;
  var visible = (+root.dataset.visible || 6) * 1000;
  var gap = (+root.dataset.gap || 25) * 1000;
  var shows = +root.dataset.shows || 3;
  var timer;

  function show() {
    if (shows-- <= 0) return;
    root.classList.add('is-open');
    timer = setTimeout(hide, visible);
  }
  function hide() {
    root.classList.remove('is-open');
    if (shows > 0) timer = setTimeout(show, gap);
  }
  function stop() {
    clearTimeout(timer);
    root.classList.remove('is-open');
    try { sessionStorage.setItem(KEY, '1'); } catch (e) {}
  }

  root.querySelector('[data-vwa-close]').addEventListener('click', stop);
  root.querySelectorAll('[data-vwa-open]').forEach(function (a) { a.addEventListener('click', stop); });
  timer = setTimeout(show, first);
})();

  } catch(e) { console.error(e); }
})();
})();
